import PropTypes from 'prop-types';

// ==============================|| PRESET THEME - DEFAULT ||============================== //

const Default = (colors) => {
  const { red, gold, green, grey } = colors;
  const greyColors = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16]
  };
  const contrastText = '#fff';

  // Custom primary color palette - Gray (#575756)

  


 // Custom primary color palette - Purple (#614CE1)
  const primaryColors = [
    '#E8E5FA', // lighter
    '#D3CDF5', // 100
    '#B9AFF0', // 200
    '#9483E8', // light
    '#6650D6', // 400
    '#352481', // main - tu color principal especificado
    '#2A1D67', // dark
    '#1F154D', // 700
    '#160F38', // darker
    '#0F0A28'  // 900
  ];

  // Custom secondary color palette - Black (#000000)
  const secondaryColors = [
    '#F5F5F5', // lighter
    '#E8E8E8', // 100
    '#D1D1D1', // 200
    '#B8B8B8', // light
    '#666666', // 400
    '#000000', // main - your specified secondary color
    '#1A1A1A', // dark
    '#333333', // 700
    '#4D4D4D', // darker
    '#666666'  // 900
  ];

  // Custom tertiary/info color palette - Pink (#DC98C4)
  const tertiaryColors = [
    '#FCF0F8', // lighter
    '#F7E0F0', // 100
    '#F0C2E1', // 200
    '#E8A4D2', // light
    '#E086C3', // 400
    '#DC98C4', // main - your specified tertiary color
    '#C679A5', // dark
    '#B05A86', // 700
    '#9A3B67', // darker
    '#841C48'  // 900
  ];



  return {
    primary: {
      lighter: primaryColors[0],
      100: primaryColors[1],
      200: primaryColors[2],
      light: primaryColors[3],
      400: primaryColors[4],
      main: primaryColors[5],
      dark: primaryColors[6],
      700: primaryColors[7],
      darker: primaryColors[8],
      900: primaryColors[9],
      contrastText
    },
    secondary: {
      lighter: secondaryColors[0],
      100: secondaryColors[1],
      200: secondaryColors[2],
      light: secondaryColors[3],
      400: secondaryColors[4],
      main: secondaryColors[5],
      600: secondaryColors[6],
      dark: secondaryColors[7],
      800: secondaryColors[8],
      darker: secondaryColors[9],
      A100: greyColors[0],
      A200: greyColors.A400,
      A300: greyColors.A700,
      contrastText: '#fff'
    },
    error: {
      lighter: red[0],
      light: red[2],
      main: red[4],
      dark: red[7],
      darker: red[9],
      contrastText
    },
    warning: {
      lighter: gold[0],
      light: gold[3],
      main: gold[5],
      dark: gold[7],
      darker: gold[9],
      contrastText: greyColors[100]
    },
    tertiary: {
      lighter: tertiaryColors[0],
      100: tertiaryColors[1],
      200: tertiaryColors[2],
      light: tertiaryColors[3],
      400: tertiaryColors[4],
      main: tertiaryColors[5],
      600: tertiaryColors[6],
      dark: tertiaryColors[7],
      800: tertiaryColors[8],
      darker: tertiaryColors[9],
      contrastText
    },
    info: {
      lighter: tertiaryColors[0],
      light: tertiaryColors[3],
      main: tertiaryColors[5],
      dark: tertiaryColors[7],
      darker: tertiaryColors[9],
      contrastText
    },
    success: {
      lighter: green[0],
      light: green[3],
      main: green[5],
      dark: green[7],
      darker: green[9],
      contrastText
    },
    grey: greyColors
  };
};

Default.propTypes = {
  colors: PropTypes.object
};

export default Default;
